import { render, staticRenderFns } from "./ModalRegisterReservationStaff.vue?vue&type=template&id=6f4dddf0&scoped=true&"
import script from "./ModalRegisterReservationStaff.vue?vue&type=script&lang=js&"
export * from "./ModalRegisterReservationStaff.vue?vue&type=script&lang=js&"
import style0 from "./ModalRegisterReservationStaff.vue?vue&type=style&index=0&id=6f4dddf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4dddf0",
  null
  
)

export default component.exports